export function isSpectraData1D(spectrum) {
    return 'ranges' in spectrum;
}
//# sourceMappingURL=isSpectraData1D.js.map